import { SuperSpeedIconComponent } from './super-speed-icon';
export const SuperSpeedIcon = SuperSpeedIconComponent;